import axios from "axios";
import ApiClient from "../http/ApiClient";
import Url from "../http/Url";
import ChangePwd from "../login/ChangePwd";

const NocService = {
    saveDraftNoc: async function (data) {
        data['applicationStatus'] = "D"
        return await ApiClient.post(Url.NOC.SAVE_NOC, data);
    },
    saveNoc: async function (data) {
        data['applicationStatus'] = "S"
        return await ApiClient.post(Url.NOC.SAVE_NOC, data);
    },
    getDesignation: async function (data) {
        return await ApiClient.get(Url.NOC.GET_DESIGNATION);
    },
    getDept: async function (data) {
        return await ApiClient.get(Url.NOC.GET_DEPT);
    },
    getApprovedList: async function (user, page, size) {
        return await ApiClient.get(Url.WF.GET_APPROVED_LIST + '/' + user + '/' + page + '/' + size);
    },
    getNocByStatus: async function (data) {
        return await ApiClient.get(Url.NOC.GET_NOC_STATUS + data);
    },
    getNocById: async function (data) {
        return await ApiClient.get(Url.NOC.GET_NOC_ID + data);
    },
    getNocByPass: async function (data) {
        return await ApiClient.get(Url.NOC.GET_NOC_PASS + data);
    },
    pendingNoc: async function () {
        return await ApiClient.get(Url.NOC.GET_PENDING_NOC + '1/P/' + sessionStorage.getItem("user"));
    },
    getActionForTask: async function (pt) {
        const response = await ApiClient.get(Url.WF.GET_ACTION + pt);
        return response;
    },
    saveApproval: async function (data) {
        return await ApiClient.post(Url.NOC.SAVE_NOC_APPROVAL, data);
    },
    ChangePassword: async function (data) {
        return await ApiClient.post(Url.Login.CHANGE_PWD, data);
    },
    sendOtp: async function (mobile) {
        return await ApiClient.get(Url.Login.SEND_OTP + mobile);
    },
    historyNoc: async function (nocId) {
        return await ApiClient.get(Url.NOC.HISTORY_NOC + nocId);
    },
    pdfNocDoc: function (fileId) {
        return ApiClient.download(Url.DOC.DOWNLOAD_FILE, fileId);
    },
    downloadPdfForVF: function (applicationId) {
        return ApiClient.download(Url.NOC.DOWNLOAD_PDF_FOR_VF, applicationId);
    },
    downloadPDFForHOD: function (applicationId, user) {
        return ApiClient.download(Url.NOC.DOWNLOAD_PDF_FOR_HOD + applicationId + "/" + user, "");
    },
    downloadPdfForRej: function (applicationId, remarks) {
        return ApiClient.download(Url.NOC.DOWNLOAD_PDF_FOR_RETURN + "/" + applicationId + "/" + remarks.value, "");
    },
    dashboardAction: async function (actionId) {
        const response = await ApiClient.get(`${Url.WF.DASHBOARD_ACTION}?actionId=${actionId}`);
        return response;
    }


}

export default NocService;